module.exports = __webpack_public_path__ + "static/media/1_person.039c648c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/1_person.svg
// module id = 2169
// module chunks = 0